var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.205 5.01018L7.79 2.59518C7.605 2.41018 7.35 2.30518 7.085 2.30518H2.5C1.95 2.30518 1.5 2.75518 1.5 3.30518V10.3052C1.5 10.8552 1.95 11.3052 2.5 11.3052H9.5C10.05 11.3052 10.5 10.8552 10.5 10.3052V5.72018C10.5 5.45518 10.395 5.20018 10.205 5.01018ZM3.5 4.30518H7V5.30518H3.5V4.30518ZM8.5 9.30518H3.5V8.30518H8.5V9.30518ZM8.5 7.30518H3.5V6.30518H8.5V7.30518Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.55a8b7ed8adb0a791a8edee2c63654d6.svg";
export { ForwardRef as ReactComponent };